/* ============================================================
   ESCORPIÓN — Ventas (oct 2026)
   1. Fecha estimada de llegada en [data-esc-entrega] (rango de fechas, no "semanas").
   2. Ficha: talla obligatoria (no viene preseleccionada), resumen con el total de
      camiseta + nombre y número + parches y "Comprar ahora" propio
      (el de Shopify se saltaba los complementos).
   3. Carrito: botones "Completa tu pedido" (parche, personalización, otra camiseta).
   4. Tarjeta "Agregado al carrito": subtotal, barra de envío gratis y fecha.
   ============================================================ */
(function () {
  var dinero = function (pesos) { return '$' + Math.round(pesos).toLocaleString('es-CO'); };
  // "$100.000,00 COP" → 100000
  var pesosDe = function (txt) {
    var m = (txt || '').replace(/\s/g, '').match(/\$?([\d.]+)(,\d+)?/);
    return m ? parseInt(m[1].replace(/\./g, ''), 10) : 0;
  };
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- 1. Fecha estimada ---------- */
  function rangoFechas(min, max) {
    var hoy = new Date();
    var a = new Date(hoy.getTime() + min * 864e5);
    var b = new Date(hoy.getTime() + max * 864e5);
    var mes = function (d) { return d.toLocaleDateString('es-CO', { month: 'long' }); };
    if (a.getMonth() === b.getMonth()) return 'el ' + a.getDate() + ' y el ' + b.getDate() + ' de ' + mes(b);
    return 'el ' + a.getDate() + ' de ' + mes(a) + ' y el ' + b.getDate() + ' de ' + mes(b);
  }
  function pintarFechas(ctx) {
    (ctx || document).querySelectorAll('[data-esc-entrega]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 25, max = parseInt(el.dataset.max, 10) || 42;
      var t = el.querySelector('[data-esc-fecha]');
      if (t) t.innerHTML = 'Llega entre <strong>' + rangoFechas(min, max) + '</strong>';
    });
  }
  window.escPintarFechas = pintarFechas;

  /* ---------- 2. Ficha de producto ---------- */
  function ficha() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var tallas = document.querySelector('[data-esc-talla-req]');
    var ayuda = document.querySelector('[data-esc-talla-aviso]');
    var atc = form.querySelector('[name="add"]');

    /* La tienda no hace cambios de talla: no se preselecciona ninguna. Solo al cargar y si
       la URL no trae ?variant=; al elegir, el tema vuelve a pintar el selector con la marcada. */
    var tallasEl = function () { return document.querySelector('[data-esc-talla-req]'); };
    if (tallas && !/[?&]variant=/.test(window.location.search)) {
      tallas.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { r.checked = false; });
    }

    var tallaElegida = function () {
      tallas = tallasEl() || tallas;
      if (!tallas) return true;
      return !!tallas.querySelector('input[type="radio"]:checked, select option:checked:not([value=""])');
    };
    var avisarTalla = function () {
      if (ayuda) { ayuda.hidden = false; ayuda.textContent = 'Elige tu talla para continuar.'; }
      if (tallas) {
        tallas.classList.add('esc-talla--error');
        tallas.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
    if (tallas) {
      tallas.addEventListener('change', function () {
        tallas.classList.remove('esc-talla--error');
        if (ayuda) ayuda.hidden = true;
      });
    }
    // En "window" y en captura: corre antes que parches, personalización y el tema.
    window.addEventListener('submit', function (e) {
      if (e.target !== form || tallaElegida()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      avisarTalla();
    }, true);

    /* Resumen de la compra: camiseta + extras */
    var resumen = document.querySelector('[data-esc-resumen]');
    var precioEl = document.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    var perso = document.querySelector('.esc-perso__input');
    var persoPrecio = pesosDe((document.querySelector('.esc-perso__price') || {}).textContent);
    var parches = function () { return Array.prototype.slice.call(document.querySelectorAll('.esc-parches__checkbox')); };

    function pintarResumen() {
      if (!resumen) return;
      var base = pesosDe(precioEl ? precioEl.textContent : '');
      var lineas = [], total = base;
      if (perso && perso.checked) { lineas.push(['Nombre y número', persoPrecio]); total += persoPrecio; }
      parches().forEach(function (cb) {
        if (!cb.checked) return;
        var p = (parseInt(cb.dataset.price, 10) || 0) / 100;
        lineas.push([cb.dataset.title.replace(/^Parche /, 'Parche ').replace(/ \(.*\)$/, ''), p]);
        total += p;
      });
      if (!lineas.length || !base) { resumen.hidden = true; return; }
      resumen.hidden = false;
      resumen.innerHTML =
        '<p class="esc-resumen__linea"><span>Camiseta</span><span>' + dinero(base) + '</span></p>' +
        lineas.map(function (l) { return '<p class="esc-resumen__linea"><span>+ ' + l[0] + '</span><span>' + dinero(l[1]) + '</span></p>'; }).join('') +
        '<p class="esc-resumen__total"><span>Total</span><span>' + dinero(total) + '</span></p>' +
        '<p class="esc-resumen__nota">Todo entra junto con «Agregar al carrito».</p>';
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches('.esc-perso__input, .esc-parches__checkbox')) pintarResumen();
    });
    if (precioEl && window.MutationObserver) {
      new MutationObserver(pintarResumen).observe(precioEl.closest('[id^="price-"]'), { childList: true, subtree: true });
    }
    pintarResumen();

    /* Comprar ahora: agrega con el formulario (talla, parches y personalización incluidos)
       y, cuando el tema confirma que la camiseta entró, va al pago. */
    var irAlPago = false;
    // PUB_SUB_EVENTS es un "const" global de constants.js: no cuelga de window.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'product-form') return;
        if (irAlPago) { window.location.href = raiz + 'checkout'; return; }
        if (perso && perso.checked) { perso.checked = false; perso.dispatchEvent(new Event('change', { bubbles: true })); }
        pintarResumen();
      });
      subscribe(PUB_SUB_EVENTS.cartError, function () { irAlPago = false; });
    }
    document.querySelectorAll('[data-esc-comprar-ahora]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!tallaElegida()) { avisarTalla(); return; }
        irAlPago = true;
        if (atc) atc.click();
      });
    });
    window.escComprarAhora = function () {
      if (!tallaElegida()) { avisarTalla(); return false; }
      irAlPago = true;
      if (atc) atc.click();
      return true;
    };
  }

  /* ---------- 3. Carrito: completa tu pedido ---------- */
  function agregar(items) {
    return fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'No se pudo agregar.'); });
      return r.json();
    });
  }
  function repintarCarrito(cx) {
    // Recarga las secciones del carrito para que los totales y las líneas queden al día.
    var ids = [cx.dataset.section];
    document.querySelectorAll('[id^="shopify-section-"][id*="cart-items"], [id^="shopify-section-"][id*="cart-footer"]').forEach(function (s) {
      ids.push(s.id.replace('shopify-section-', ''));
    });
    return fetch(raiz + 'cart?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        Object.keys(secs).forEach(function (id) {
          var actual = document.getElementById('shopify-section-' + id);
          if (!actual || !secs[id]) return;
          var nuevo = new DOMParser().parseFromString(secs[id], 'text/html').getElementById('shopify-section-' + id);
          if (nuevo) actual.replaceWith(nuevo);
        });
        carrito();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { window.location.reload(); });
  }
  /* La cantidad de cada complemento sigue a su camiseta ("Para la camiseta"); si la camiseta
     ya no está, el complemento sale. Evita, p. ej., un parche ×2 para una sola camiseta. */
  function sincronizarComplementos() {
    return fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var esAddon = function (it) { return it.product_type === 'Parche' || it.product_type === 'Servicio'; };
        var cantidad = {};
        c.items.forEach(function (it) {
          if (esAddon(it)) return;
          var et = it.product_title + ' — Talla ' + it.variant_title;
          cantidad[et] = (cantidad[et] || 0) + it.quantity;
        });
        var updates = {}, hay = false;
        c.items.forEach(function (it) {
          var para = it.properties && it.properties['Para la camiseta'];
          if (!esAddon(it) || !para) return;
          var q = cantidad[para] || 0;
          if (q !== it.quantity) { updates[it.key] = q; hay = true; }
        });
        if (!hay) return false;
        return fetch(raiz + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () { return true; });
      });
  }
  var sincronizando = false;
  function alCambiarCarrito() {
    var cx = document.querySelector('[data-esc-cx]');
    document.dispatchEvent(new CustomEvent('cart:refresh')); // contador del header
    if (!cx || sincronizando) return;
    sincronizando = true;
    sincronizarComplementos()
      .catch(function () { return false; })
      .then(function () { return repintarCarrito(document.querySelector('[data-esc-cx]') || cx); })
      .then(function () { sincronizando = false; }, function () { sincronizando = false; });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === 'product-form') return; // la ficha tiene su propio flujo
      alCambiarCarrito();
    });
  }

  function carrito() {
    var cx = document.querySelector('[data-esc-cx]');
    if (!cx || cx.dataset.listo) return;
    cx.dataset.listo = '1';
    pintarFechas(cx);
    var error = cx.querySelector('[data-esc-cx-error]');
    var ocupado = function (btn, si) { if (btn) { btn.disabled = si; btn.classList.toggle('is-busy', si); } };
    var fallar = function (btn, err) {
      ocupado(btn, false);
      if (error) { error.hidden = false; error.textContent = err.message || 'No se pudo agregar. Intenta de nuevo.'; }
    };

    cx.addEventListener('click', function (e) {
      var b = e.target.closest('[data-esc-add]');
      if (b) {
        ocupado(b, true);
        var props = {};
        try { props = JSON.parse(b.dataset.props || '{}'); } catch (x) {}
        agregar([{ id: parseInt(b.dataset.id, 10), quantity: parseInt(b.dataset.qty, 10) || 1, properties: props }])
          .then(function () { return repintarCarrito(cx); })
          .catch(function (err) { fallar(b, err); });
        return;
      }
      var abrir = e.target.closest('[data-esc-perso-abrir]');
      if (abrir) {
        var f = abrir.nextElementSibling;
        f.hidden = !f.hidden;
        abrir.setAttribute('aria-expanded', String(!f.hidden));
        if (!f.hidden) f.querySelector('input').focus();
        return;
      }
      var sel = e.target.closest('[data-esc-add-sel]');
      if (sel) {
        var select = sel.parentNode.querySelector('[data-esc-talla]');
        if (!select.value) { select.classList.add('esc-talla--error'); select.focus(); return; }
        ocupado(sel, true);
        agregar([{ id: parseInt(select.value, 10), quantity: 1 }])
          .then(function () { return repintarCarrito(cx); })
          .catch(function (err) { fallar(sel, err); });
      }
    });
    cx.addEventListener('change', function (e) {
      if (e.target.matches('[data-esc-talla]')) e.target.classList.remove('esc-talla--error');
    });
    cx.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-esc-perso-form]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      ocupado(btn, true);
      agregar([{
        id: parseInt(f.dataset.id, 10),
        quantity: parseInt(f.dataset.qty, 10) || 1,
        properties: {
          Nombre: f.nombre.value.trim().toUpperCase(),
          'Número': f.numero.value.trim(),
          'Para la camiseta': f.dataset.para,
        },
      }]).then(function () { return repintarCarrito(cx); }).catch(function (err) { fallar(btn, err); });
    });
  }

  /* ---------- 4. Tarjeta "Agregado al carrito" ---------- */
  function extrasTarjeta() {
    var caja = document.querySelector('[data-esc-toast-extra]');
    if (!caja) return;
    fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var umbral = parseInt(caja.dataset.umbral, 10) || 0; // en centavos
        var html = '<p class="esc-toast-x__sub"><span>Subtotal del carrito</span><strong>' + dinero(c.total_price / 100) + '</strong></p>';
        if (umbral > 0) {
          var falta = umbral - c.total_price;
          var pct = Math.min(100, Math.round((c.total_price * 100) / umbral));
          html += '<p class="esc-toast-x__envio">' + (falta > 0
            ? 'Te faltan <strong>' + dinero(falta / 100) + '</strong> para el envío gratis'
            : '<strong>¡Tienes envío gratis!</strong>') + '</p>' +
            '<div class="esc-toast-x__barra"><i style="width:' + pct + '%"></i></div>';
        }
        html += '<p class="esc-toast-x__fecha" data-esc-entrega data-min="' + caja.dataset.min + '" data-max="' + caja.dataset.max + '"><span data-esc-fecha></span></p>';
        caja.innerHTML = html;
        pintarFechas(caja);
      })
      .catch(function () {});
  }
  document.addEventListener('esc:toast-open', extrasTarjeta);

  /* ---------- 5. "Más de <equipo>": filtros rápidos ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-esc-mas] .esc-mas__chip');
    if (!chip) return;
    var caja = chip.closest('[data-esc-mas]');
    var tipo = chip.dataset.tipo;
    caja.querySelectorAll('.esc-mas__chip').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', String(on));
    });
    caja.querySelectorAll('.esc-mas__item').forEach(function (li) {
      li.hidden = !!tipo && (' ' + li.dataset.tipos + ' ').indexOf(' ' + tipo + ' ') === -1;
    });
    var lista = caja.querySelector('.esc-mas__lista');
    if (lista) { lista.scrollTop = 0; lista.scrollLeft = 0; }
  });

  /* ---------- 6. Guía de tallas en pop-up ---------- */
  function guia() {
    var dlg = document.querySelector('[data-esc-guia]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var clave = { retro: 'retro', jugador: 'jugador', 'niños': 'niños', fan: 'fan' }[dlg.dataset.seccion] || 'fan';
    document.querySelectorAll('[data-esc-guia-abrir]').forEach(function (b) {
      b.addEventListener('click', function () {
        dlg.showModal();
        document.documentElement.classList.add('esc-flt-bloqueo');
        // Lleva a la tabla de este tipo de camiseta (fan, jugador, retro o niños)
        var h = Array.prototype.find.call(dlg.querySelectorAll('.esc-guia__cuerpo h2'), function (x) { return x.textContent.toLowerCase().indexOf(clave) !== -1; });
        var cuerpo = dlg.querySelector('.esc-guia__cuerpo');
        if (h && cuerpo) { cuerpo.scrollTop = h.offsetTop - 12; h.classList.add('esc-guia__resaltado'); }
      });
    });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('esc-flt-bloqueo'); });
    dlg.querySelectorAll('[data-esc-guia-cerrar]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    // Clic fuera del recuadro cierra
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  function arrancar() { pintarFechas(); ficha(); carrito(); guia(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
